


















import { listFactory } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';

import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter,getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { NAME, addThreeMonths, subtractOneDay } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.OrganizationIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.OrganizationIds);
		},
	},
	methods: {
		async exportFun() {
			try {
				if (this.filter.OrganizationIds == null || this.filter.OrganizationIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetPendingJobsSafetyRemarksListReport(new Date(this.OrderFromDate!).toISOString(),
						new Date(this.OrderToDate!).toISOString(), this.OrganizationIds,getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), columnsSeq);
				}
			} catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},

		dateValidation() {
             if (this.OrderFromDate && this.OrderToDate)
            {                  
                const startMonth = this.OrderFromDate.getMonth();
				const endMonth = this.OrderToDate.getMonth();
				const checkDateRange = new Date(this.OrderFromDate.getFullYear(), this.OrderFromDate.getMonth() + addThreeMonths, this.OrderFromDate.getDate()- subtractOneDay);
				if(this.OrderToDate>checkDateRange){
					this.showErrorAlert({ message: this.LocalizePopisPoli('VALIDATION_FOR_THREE_MONTH') });
                    this.OrderFromDate = null;
                    this.OrderToDate = null;
                    return false;
				}
            }
        },

		async filterClick() {
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.OrganizationIds,
				(columnsSeq) => ({
					OrganizationIds: this.OrganizationIds,
					OrderFromDate: this.OrderFromDate,
					OrderToDate: this.OrderToDate,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
	},
});
